module.exports = __webpack_public_path__ + "static/img/fullscreen-image_our-services_600.c86e146.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/consulting/fullscreen-image_our-services_600.png
// module id = BRWc
// module chunks = 0